import { Skeleton } from '@digibee/beehive-ui';

import * as Elements from './BadgeLoading.elements';

const BadgeLoading = ({ itemsProps }) => {
  const items = Array(itemsProps)
    .fill(undefined)
    .map((val, idx) => idx);

  return (
    <Elements.Container>
      {items.map(item => (
        <Elements.Content key={item}>
          <Skeleton sizes='medium' variant='rectangular' animation='pulse' />
          <Elements.Separator />
        </Elements.Content>
      ))}
    </Elements.Container>
  );
};

export default BadgeLoading;
